import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
// -
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import NavBreadcrum from "components/NavBreadcrum";
import axiApi from "ApiCaller";
import TableUpdates from "./updates/TableUpdates";
import FilterUpdates from "./updates/FilterUpdates";
import ModalFirmwareSelect from "./updates/ModalFirmwareSelect";
import navs from "./navs";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";
import ItemsModel from "core/itemsModel";
import useCustomTranslation from "core/customTranslation";

const ParamsDefaults = {models: []};
const buttonsActions = {
    title: "",
    edit: {
        active: true,
        disabled: true,
        onClick: () => {},
    },
    send: {
        active: true,
        disabled: true,
        onClick: () => {},
    },
};

const translations = {
    es: {
        "question.busy.title": "Colas ocupadas: ",
        "question.busy.text": "¿Desea vaciarlas y enviar la actualización?",
    },
    en: {
        "question.busy.title": "Busy queues: ",
        "question.busy.text": "Do you want to empty the queues and send the update?",
    },
};
const ViewUpdates = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tt} = useTranslation("tags");
    const {t: _Tc} = useCustomTranslation(translations);
    document.title = "Actualizaciones";

    const bread = [
        {name: _Tr("labels.advanced"), url: "/advanced/", current: false},
        {name: document.title, current: true},
    ];
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const QuestionWarning = new SwalAlertChoice({
        iconColor: "#ddb655",
        confirmButtonText: _Tf("labels.accept"),
        cancelButtonText: _Tf("labels.cancel"),
    });

    const firmwares = useRef({
        all: [],
        showed: [],
        select: null,
    });
    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [checkedAll, setCheckedAll] = useState(false);
    const [params, setParams] = useState({...ParamsDefaults});
    const [isLoading, setIsLoading] = useState(false);
    const [buttonsTB, setButtonsTB] = useState({
        ...buttonsActions,
        title: document.title,
    });
    // data table
    const [itemsShown, setItemsShown] = useState([]);
    const [showModalSend, setShowModalSend] = useState(false);
    const [model, setModel] = useState(null);
    const [showPrev, setShowPrev] = useState(false);
    const [item, setItem] = useState({});
    //const [showCanvas, setShowCanvas] = useState(false);

    const headersTable = [
        {
            name: (
                <>
                    UUID
                    <br />
                    {_Tt("common.model")}
                </>
            ),
            attr: 0,
            direction: "asc",
            active: true,
            default: true,
        },
        {name: _Tt("common.version"), attr: 1, direction: "asc", active: false},
        {name: _Tt("common.installed"), attr: 2, direction: "asc", active: false},
    ];

    useEffect(() => {
        const buttons = {...buttonsTB};
        buttons.title = document.title;
        buttons.send.disabled = true;
        buttons.send.onClick = onClickSend;
        setButtonsTB(buttons);
        pagerModelRef.current.handleCallApi = () => fetchUpdates();
        fetchGetUpdates();
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchUpdates();
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = {};
        filters.current.filter = (e) => {
            pagerModelRef.current.paging.page = 1;
            fetchUpdates();
        };
        // -
    }, []);

    const fetchGetUpdates = () => {
        setIsLoading(true);
        axiApi
            .get("/api/devices/advanced/updates/")
            .then((resp) => {
                pagerModelRef.current.active = resp.data.items.length > 0;
                items.current.showed = [...resp.data.items];
                setItemsShown([...resp.data.items]);
                setParams({
                    ...ParamsDefaults,
                    models: [...resp.data.models],
                    device_groups: [...resp.data.device_groups],
                    container_groups: [...resp.data.container_groups],
                    versions: resp.data.versions ? [...resp.data.versions] : [],
                });
                pagerModelRef.current.paging.setPager(resp.data);
            })
            .finally(() => setIsLoading(false));
    };
    const fetchUpdates = () => {
        setIsLoading(true);
        axiApi
            .post("/api/devices/advanced/updates/", filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                pagerModelRef.current.active = resp.data.items.length > 0;
                items.current.setShowed(resp.data.items);
                setItemsShown([...resp.data.items]);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .catch((error) => {
                console.error(error);
                Alert.error("Error en el servidor", "Avise al administrador.");
            })
            .finally(() => setIsLoading(false));
    };

    const onClickSend = async (e) => {
        setModel(items.current.showed[0].model);
        let queueBusy = 0;
        let indexes = items.current.chosen
            .map((uuid) => items.current.showed.findIndex((item) => item.uuid === uuid))
            .filter((index) => index !== -1);
        indexes.forEach((idx) => {
            if (items.current.showed[idx].queue) {
                queueBusy++;
            }
        });
        if (queueBusy > 0) {
            const quest = await QuestionWarning.question(_Tc("question.busy.title") + queueBusy, _Tc("question.busy.text"));
            if (!quest.isConfirmed) {
                return false;
            }
        }
        setShowModalSend(true);
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <FilterUpdates params={params} actions={buttonsTB} filters={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="150px" chosen={items.current.chosen} />
            <div className="row">
                <div className="col">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableUpdates
                            items={items}
                            itemsShow={itemsShown}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            checkAll={checkedAll}
                            setCheckAll={setCheckedAll}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
            </div>
            {showModalSend ? (
                <ModalFirmwareSelect
                    show={showModalSend}
                    setShow={setShowModalSend}
                    items={items}
                    firmwares={firmwares}
                    model={model}
                    setItemsParent={setItemsShown}
                />
            ) : (
                <></>
            )}
        </>
    );
};
export default ViewUpdates;
